import React from 'react';
import { Group, Path, Text, Rect, Circle } from 'react-konva';
import { colorToArray } from '../../lib/ep';

const w = 60;
const h = 72;

const football_items = {
	dorsal_props:{
		type:'text',
		align:'middle',
		align_konva:'center',
		x:w / 2,
		y:w / 2,
		y_displacement:15,
		width:40,
	},
	items:[{
		type:'path',
		stroke_width:'thick',
		is_main:true,
		data:'M30,72c-12.1,0-18-3.6-18-3.6s-0.3-0.6,0-1.8c0.7-3,2.4-9.5,2.4-18.6c0-12.2-1.2-18-1.2-18L12,31.8L11.4,33 C9.2,33.5,1.8,31.5,0,30.6v-1.8c0,0,2.2-7.2,3.6-12c1.1-4.4,1.4-8.9,9-11.4s8.3-3.7,9-4.2C22.3,0.7,23.4,0,23.4,0s3.1,1.2,6.6,1.2S36.6,0,36.6,0s1.1,0.7,1.8,1.2s1.4,1.7,9,4.2s7.9,7,9,11.4c1.4,4.8,3.6,12,3.6,12v1.8c-1.8,0.9-9.2,2.9-11.4,2.4L48,31.8L46.8,30c0,0-1.2,5.8-1.2,18c0,9.1,1.7,15.6,2.4,18.6c0.3,1.2,0,1.8,0,1.8S42.1,72,30,72z',
		stroke_width_num:1,
	}, {
		type:'path',
		stroke_width:'thick',
		data:'M13.2,30c-0.5-5.3-3.4-10-4.8-18',
		stroke_width_num:0.5,
	}, {
		type:'path',
		stroke_width:'thick',
		data:'M46.8,30c0.5-5.3,3.4-10,4.8-18',
		stroke_width_num:0.5,
	}, {
		type:'path',
		stroke_width:'thin',
		data:'M0,28.8c1.3,0.7,7.5,2.7,12,3',
		stroke_width_num:0.5,
	}, {
		type:'path',
		stroke_width:'thin',
		data:'M60,28.8c-1.3,0.7-7.5,2.7-12,3',
		stroke_width_num:0.5,
	}, {
		type:'path',
		stroke_width:'thin',
		data:'M38.4,1.2c-2.1,1.5-5.9,2.2-8.4,2.2c-2.5,0-6.3-0.6-8.4-2.2',
		stroke_width_num:0.5,
	}, {
		type:'path',
		stroke_width:'thin',
		data:'M48,66.6c-6.2,2.5-11.7,3.6-18,3.6s-11.8-1.1-18-3.6',
		stroke_width_num:0.5,
	}],
};

const basketball_items = {
	dorsal_props:{
		type:'text',
		align:'middle',
		align_konva:'center',
		x:w / 2,
		y:w / 2 + 17,
		y_displacement:15 + 17,
		width:40,
	},
	items:[{
		type:'path',
		stroke_width:'thick',
		is_main:true,
		data:'M30,72c13.3,0,21-3,21-3c-1.7-21.1-0.1-32.3,0-42v-2c-5.3-3.9-6.7-17.4-5-23.5c0,0-1.3-0.2-2-0.2l-4-0.8C39.2,0.1,38,0,38,0c-1.5,0.8-4.8,2-8,2s-6.5-1.2-8-2c0,0-1.2,0.1-2,0.5l-4,0.8c-0.7,0-2,0.2-2,0.2c1.7,6.1,0.3,19.6-5,23.5v2c0.1,9.7,1.7,20.9,0,42C9,69,16.7,72,30,72z',
		stroke_width_num:1,
	}, {
		type:'path',
		stroke_width:'thin',
		data:'M16,1.3c1.9,7.6,0.5,21.3-7,25.7',
		stroke_width_num:0.5,
	}, {
		type:'path',
		stroke_width:'thin',
		data:'M44,1.3c-1.9,7.6-0.5,21.3,7,25.7',
		stroke_width_num:0.5,
	}, {
		type:'path',
		stroke_width:'thin',
		data:'M40.1,0.5C37.7,3,33.2,4,30,4s-7.7-1-10.1-3.5',
		stroke_width_num:0.5,
	}],
};

const circle_items = {
	dorsal_props:{
		type:'text',
		align:'middle',
		align_konva:'center',
		x:w / 2,
		y:w / 2 + 13,
		y_displacement:20,
		width:40,
	},
	items:[{
		type:'circle',
		radius:30,
		stroke_width:'wide',
		stroke_width_num:1,
		x:w / 2,
		y:w / 2,
		is_main:true,
	}],
};

const rect_items = {
	dorsal_props:{
		type:'text',
		align:'middle',
		align_konva:'center',
		x:w / 2,
		y:w / 2 + 7,
		y_displacement:20,
		width:40,
	},
	items:[{
		type:'rect',
		width:w,
		height:w,
		stroke_width:'wide',
		stroke_width_num:1,
		is_main:true,
	}],
};

const DefaultSportsShirt = (props) => {
	const is_konva = props?.is_konva ?? false;
	const type = props?.type ?? 'football';
	const dorsal = props?.dorsal ?? null;
	const color = props?.color ?? `rgba(var(--main-color, ${colorToArray('#2330BE')}), 1)`;
	const text_color = props?.text_color ?? 'rgba(255, 255, 255, 1)';
	const decoration_img = props?.decoration_img ?? false;
	const in_scale = props?.in_scale ?? 1;
	const paint_dorsal = props?.paint_dorsal ?? true;
	const id = `shirt_decoration_${props?.id ?? 'candidate_img'}`;

	let shirt_items;
	switch(type) {
		case 'basketball':
			shirt_items = {...basketball_items};
			break;

		case 'circle':
			shirt_items = {...circle_items};
			break;

		case 'rect':
			shirt_items = {...rect_items};
			break;

		case 'football':
		default:
			shirt_items = {...football_items};
			break;
	}

	const items = [...shirt_items.items];

	if(dorsal != undefined) {
		items.push({
			...shirt_items.dorsal_props,
			data:dorsal,
		});
	}

	/*if(is_konva) {
		return (
			<Group {...props.konvaProps}>
				<Rect
					width={60}
					height={60}
					fill='blue'
					x={0}
				/>
			</Group>
		)
	}*/

	if(is_konva) {
		return (
			<Group {...props.konvaProps}>
				{items.map((item, i) => {
					const item_str = item?.type ?? 'path';
					let Item = Path;
					switch(item_str) {
						case 'circle':
							Item = Circle;
							break;

						case 'rect':
							Item = Rect;
							break;
					}

					if(item.type == 'text' && !paint_dorsal) {
						return null;
					}

					if(item.type == 'text' && paint_dorsal) {
						return (
							<Text
								key={`it_${i}`}
								align={item?.align_konva ?? 'left'}
								x={(w - (item?.width ?? 40)) / 2}
								y={item?.y_displacement ?? 15}
								width={(item?.width ?? 40)}
								fontSize={23}
								fontFamily='Dorsal'
								text={item.data}
								fill={text_color}
							/>
						)
					}

					const is_main = item?.is_main ?? false;

					if(is_main) {
						const has_loaded_img = (decoration_img !== false && decoration_img.img != undefined) ? true : false;

						const decoration_img_scale = (has_loaded_img) ? Math.min(w / decoration_img.w, h / decoration_img.h) : 1;

						return (
							<Item
								key={`it_${i}`}
								data={item.data}
								radius={item.radius}
								x={item.x}
								y={item.y}
								width={item.width}
								height={item.height}
								strokeWidth={(item?.stroke_width_num ?? 1) * in_scale / decoration_img_scale}
								stroke={text_color}
								fillPatternImage={decoration_img.img}
								fillPatternRepeat='no-repeat'
								fillPatternScaleX={decoration_img_scale}
								fillPatternScaleY={decoration_img_scale}
								fillPatternX={(item_str == 'circle') ? (-w / 2) : null}
								fillPatternY={(item_str == 'circle') ? (-h / 2) : null}
								fill={color}
								fillPriority={(has_loaded_img) ? 'pattern' : 'color'}
							/>
						)
					}

					return (
						<Item
							key={`it_${i}`}
							data={item.data}
							radius={item.radius}
							x={item.x}
							y={item.y}
							width={item.width}
							height={item.height}
							strokeWidth={(item?.stroke_width_num ?? 0.5) * in_scale}
							stroke={text_color}
							fill='transparent'
						/>
					)
				})}
			</Group>
		)
	}

	let w_used = w;
	let h_used = h;
	switch(type) {
		case 'circle':
		case 'rect':
			h_used = w;
			break;
	}

	return (
		<svg
			class={`team_default_shirt ${type}_shirt`}
			viewBox={`0 0 ${w_used + 6} ${h_used + 6}`}
			style={{
				'--main-text-color':colorToArray(text_color),
				'--text-color':'var(--main-text-color)',
			}}
		>
			{(decoration_img !== false) && (
				<defs>
					<pattern id={id} patternUnits="userSpaceOnUse" width={w} height={h}>
						<image href={decoration_img} x="0" y="0" width={w} height={h} />
					</pattern>
				</defs>
			)}

			<g transform='translate(3, 3)'>
				{items.map((item, i) => {
					const Item = item?.type ?? 'path';

					if(item.type == 'text' && paint_dorsal) {
						return (
							<text
								key={`it_${i}`}
								class="text"
								textAnchor={item?.align ?? 'left'}
								fill={text_color}
								x={item?.x ?? 0}
								y={item?.y ?? 0}
							>{item.data}</text>
						)
					}

					const is_main = item?.is_main ?? false;
					let classes = [`${item.stroke_width}_line`];
					if(is_main) {
						classes.push('color');
						if(decoration_img !== false) classes.push('with_image');
					}

					return (
						<Item
							key={`it_${i}`}
							class={classes.join(" ")}
							d={item.data}
							r={item.radius}
							width={item.width}
							height={item.height}
							cx={w / 2}
							cy={h / 2}
							style={(is_main) ? { fill:(decoration_img !== false) ? `url(#${id})` : color } : null}
						/>
					)
				})}
			</g>
		</svg>
	)
};

export default DefaultSportsShirt;